<template>
  <div class="stk-p-8">
    <PortfolioCardList
      portfolio-type="modelportfolio"
    />
  </div>
</template>

<script>
import PortfolioCardList from '@frontend/dash3/js/components/portfolios/PortfolioCardList.vue';
import Advisor from '@frontend/dash3/js/shared/Advisor.js';

export default {
  components: {
    PortfolioCardList,
  },
  data() {
    return {
      advisor: {},
      host: null,
    };
  },
  created: async function() {
    this.$root.$data.csrfToken = document.querySelector('[name="csrfmiddlewaretoken"]').value;
    this.advisor = new Advisor();
    this.$root.advisor = this.advisor; // Should be on root everywhere but can debug later
    this.host = window.location.host;
    this.$root.$data.csrfToken = document.querySelector('[name="csrfmiddlewaretoken"]').value;
  },
};
</script>
